<template>
    <div class="form-field">
      <div class="form-field__title" >参赛</div>
      <div class="form-field__content competition">
          <div class="the-choosed" @click="toggleAction">
              <span>{{choosedCompetition.activityName}}</span>
              <iconfont
                name="#icon28133"
                font-size="8px"
                :class="['down', show1 ? 'up': '']"
              ></iconfont>
          </div>
          <el-collapse-transition>
          <ul class="lists" v-show="show1">
              <li :class="['ellipsis', choosedCompetition.activityId === item.activityId?'choosed': '']" v-for="(item,index) in lists" @click="chooseAction({item})" :key="'activity' + index">{{item.activityName}}</li>
          </ul>
      </el-collapse-transition>
      </div>
    </div>
</template>
<script>
export default {
    name: 'competition',
    props: {
        choosedCompetition: {
            type: Object,
            default () {
                return {};
            }
        },
        lists: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            show1: false
        }
    },
    components: {
        iconfont: () => import('@/platformCode/iconfont')
    },
    methods: {
        toggleAction () {
            this.show1 = !this.show1;
        },
        chooseAction ({item}) {
            this.toggleAction();
            this.$emit('chooseAction', {item});
        }
    }
}
</script>
<style lang="scss" scoped>

.form-field {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 14px;
}
.form-field__content {
  margin-left: 1px;
  width: 426px;
}
.form-field__title {
  width: 58px;
  text-align: left;
}

* {
    box-sizing: border-box;
}
.mt22 {
    margin-top: 22px;
}
.competition {
    position: relative;
    font-family: "Microsoft YaHei";
    text-align: left;
    .lists {
        position: absolute;
        top: 40px;
        left: 0;
        z-index: 10;
        width: 184px;
        max-height: 140px;
        background: #FFFFFF;
        box-shadow: 0px 2px 9px 0px rgba(56, 58, 66, 0.2);
        border-radius: 4px;
        overflow-y: auto;
        li {
            background-color: #fff;
            height: 34px;
            line-height: 34px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            padding: 0 14px;
            &.choosed,&:hover {
                background-color: #F6F7F9;
            }
        }
    }
    .the-choosed {
        padding: 0 14px;
        width: 184px;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #D5D5D5;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        position: relative;
        .down {
            position: absolute;
            right: 12px;
            top: 17px;
            color: #D5D5D5;
            &.up {
                transform: rotate(-180deg);
            }
        }
        .ellipsis {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/competition.vue